__turbopack_context__.v({
  "helios-card": "_39w4Aq_helios-card",
  "helios-card--full-height": "_39w4Aq_helios-card--full-height",
  "helios-card--mobile-padded-lg": "_39w4Aq_helios-card--mobile-padded-lg",
  "helios-card--mobile-padded-md": "_39w4Aq_helios-card--mobile-padded-md",
  "helios-card--mobile-padded-sm": "_39w4Aq_helios-card--mobile-padded-sm",
  "helios-card--padded-lg": "_39w4Aq_helios-card--padded-lg",
  "helios-card--padded-md": "_39w4Aq_helios-card--padded-md",
  "helios-card--padded-sm": "_39w4Aq_helios-card--padded-sm",
  "helios-card--surface-subtle": "_39w4Aq_helios-card--surface-subtle",
  "helios-card--surface-transparent": "_39w4Aq_helios-card--surface-transparent",
});
